// extracted by mini-css-extract-plugin
export default {"modal":"ProjectFormModal_modal__W8cNa","content":"ProjectFormModal_content__Cr4-I","title":"ProjectFormModal_title__ynHId","actions":"ProjectFormModal_actions__lHOQy"};